export enum DriverStatus {
  AVAILABLE = 'AVAILABLE',
  BUSY = 'BUSY',
  OFFLINE = 'OFFLINE',
  ON_DELIVERY = 'ON_DELIVERY',
  RETURNING = 'RETURNING',
  BREAK = 'BREAK',
}

export const DriverStatusLabels: Record<DriverStatus, string> = {
  [DriverStatus.AVAILABLE]: 'Activo',
  [DriverStatus.BUSY]: 'Ocupado',
  [DriverStatus.OFFLINE]: 'Desconectado',
  [DriverStatus.ON_DELIVERY]: 'En Entrega',
  [DriverStatus.RETURNING]: 'Regresando',
  [DriverStatus.BREAK]: 'En Descanso',
};
